"use client"

import { Modal, useModalStore } from "@/hooks/useModal"
import React from "react"
import { ReviewModal } from "@/components/organisms/Product/review-form"
import { PropertySearchModal } from "@/components/organisms/SearchHomeForm/modal"
import ProductCategoryForm from "@/components/organisms/ProductCategoryForm"
import { UserSession } from "@/types/session"

export function Modals() {
  const modals = useModalStore((s) => s.modals)

  return (
    <>
      {Object.entries(modals).map(([key, value]) => {
        return <React.Fragment key={key}>{value && <ModalsFactory key={key} type={key as Modal} />}</React.Fragment>
      })}
    </>
  )
}

function ModalsFactory({ type }: Readonly<{ type: Modal }>) {
  switch (type) {
    case "review":
      return <ReviewModal />
    case "property":
      return <PropertySearchModal />
    case "product-category":
      return <ProductCategoryForm />
    case "alert":
      const { AlertModal } = require("@/components/molecules/AlertModal")
      return <AlertModal />
    default:
      return null
  }
}
